import { useTranslation } from "react-i18next";

import type { TwoColumnComponentProps } from "../types";

/**
 * TwoColumnComponent - renders a two-column layout.
 * Each column can have title, description, and a nested component.
 */
function TwoColumnComponent({
  left,
  right,
  renderChild,
}: TwoColumnComponentProps) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4">
      {left && (
        <div style={left.width ? { width: left.width } : undefined}>
          {(left.title != null && left.title !== "") || left.actions ? (
            <div className="flex items-center justify-between gap-4 mb-4">
              {left.title != null && left.title !== "" && (
                <h3 className="text-lg font-semibold">{t(left.title)}</h3>
              )}
              {left.actions && (
                <div className="flex items-center gap-2">
                  {left.actions.map((action, index) => (
                    <div key={index}>{renderChild(action)}</div>
                  ))}
                </div>
              )}
            </div>
          ) : null}
          {left.description != null && left.description !== "" && (
            <p className="text-muted-foreground text-sm">
              {t(left.description)}
            </p>
          )}
          {left.value != null && renderChild(left.value)}
        </div>
      )}
      {right && (
        <div style={right.width ? { width: right.width } : undefined} className="w-full">
          {right.title != null && right.title !== "" && (
            <h3 className="text-lg font-semibold">{t(right.title)}</h3>
          )}
          {right.description != null && right.description !== "" && (
            <p className="text-muted-foreground text-sm">
              {t(right.description)}
            </p>
          )}
          {right.value != null && renderChild(right.value)}
        </div>
      )}
    </div>
  );
}

export { TwoColumnComponent };
